import { forwardRef } from "react";
function SvgRawBoltIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={2}
        d="M10 3 5 14h6v5l8-10h-6.5L15 3z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawBoltIcon);
export default ForwardRef;
